import HeaderMinimal from '../../Shared/Headers/HeaderMinimal';
import { devis } from '../../../utils/images';
import SideMenu from '../../Splitter/SideMenu/SideMenu';
import React, {
  useContext,
  useRef,
  useEffect,
  useState,
  useCallback,
} from 'react';
import QuotesCards from './QuotesCards';
import { ClientContext } from '../../Contexts/contexts';
import useAuth from '../../Contexts/useAuth';
import Services from '../../Services/services';
import useToast from '../../Toasts/useToast';
import {
  ToastHeaders,
  ToastThemes,
  ToastMessages,
} from '../../Toasts/ToastOptions/toastOptions';
import { status } from '../../../data/fetchStatus';

function Quotes() {
  const clientContext = useContext(ClientContext);
  const [activities, setActivities] = useState([]);
  const [activitiesFetched, setActivitiesFetched] = useState(status.DEFAULT);

  const { checkAuth, validateRoleRoute } = useAuth();
  const ref = useRef(true);

  const enqueueToast = useToast();

  const fetchActivities = useCallback(async () => {
    if (
      clientContext?.client === undefined ||
      activitiesFetched === status.FETCHED
    )
      return;

    setActivitiesFetched(status.FETCHED);

    try {
      const data = await Services.activitiesServices.findActivities();

      if (data.length === 0) {
        return;
      }

      const uncalculatedActivities = data.filter(
        (activity) => activity.isCalculated === false
      );

      setActivities(uncalculatedActivities);
    } catch (error) {
      enqueueToast(ToastMessages.ERROR_OCCURED_FETCH, {
        theme: ToastThemes.toastThemes.ERROR_OCCURED,
        header: ToastHeaders[ToastThemes.toastThemes.ERROR_OCCURED],
        duration: 3000,
      });
      console.error(error);
    }
  }, [enqueueToast, activitiesFetched]);

  useEffect(() => {
    const firstRendering = ref.current;

    if (checkAuth()) {
      if (validateRoleRoute('client')) {
        if (firstRendering) {
          ref.current = false;
          clientContext?.refreshClientExpertRelations();
        }
      }
    }
  }, [checkAuth, validateRoleRoute, clientContext]);

  useEffect(() => {
    fetchActivities();
  }, [fetchActivities]);

  function GetAvailableQuotes() {
    const quotes =
      clientContext?.quotes?.filter((quote) => {
        for (const relation of clientContext?.clientExpertRelations || []) {
          if (relation?.quoteId === quote?.id) return false;
        }

        return true;
      }) || [];

    return quotes.sort((a, b) => a.price - b.price);
  }

  return (
    <>
      <HeaderMinimal />
      <div className="ts-container">
        <SideMenu />
        <div className="ts-container-column">
          <div className="ts-details-container">
            <div className="ts-details">
              <div className="ts-title">Mes devis proposés</div>
              <div className="ts-resume">
                Merci de choisir l'expert qui correspond le mieux à vos
                attentes.
                <br />
                L'expert que vous sélectionnerez sera notifié et vous proposera
                cinq options de rendez-vous. <br />
                Une fois l'un de ces rendez-vous accepté, vous obtiendrez
                l'accès à ses coordonnées pour que vous puissiez le contacter,
                si besoin.
              </div>
            </div>
            <div className="ts-number">
              <div className="ts-number-container">
                <div className="ts-number-title">Devis Proposés</div>
                <div className="ts-number-current">
                  {clientContext?.clientExpertRelation !== undefined
                    ? 1
                    : Math.min(GetAvailableQuotes()?.length || 0, 3)}
                </div>
              </div>
              <img className="ts-icon" src={devis} alt="devis icone"></img>
              <div className="yellow-rod"></div>
            </div>
          </div>
          <div className="quote-cards">
            {clientContext &&
              clientContext?.clientExpertRelation === undefined &&
              GetAvailableQuotes()?.map((quote, idx) => {
                if (idx > 2) return null;

                return (
                  <QuotesCards
                    data={quote}
                    id={`quote-card-${idx}`}
                    key={idx}
                    number={idx}
                    selectExpert={() =>
                      clientContext?.selectExpert(
                        quote.id,
                        quote.expertId,
                        quote.clientId
                      )
                    }
                  />
                );
              })}
          </div>
          <div className="quote-service-disclaimer">
            * L'estimation ne prend pas en compte les services suivants :
            <span>
              {activities.map((activity) => activity.description).join(', ')}
            </span>
            . Leurs coûts nécessitent un examen approfondi de la part de
            l'expert.
          </div>
        </div>
      </div>
    </>
  );
}

// Full service TPE, Optimisation Fiscale, Conseil entreprise en difficulté,
// Etude de marché, Evaluation d'entreprise, DAF/CFO externalisé, RSE,
// Consolidation, Fusion Acquisition, Rachat d'entreprise, Transmission
// d'entreprise.

export default Quotes;
